<template>
  <div>
    <div class="txtC padBM" style="border-bottom:1px solid #ddd;">
      <img :src="`${hybrisUrl}/_ui/_noticeImg/logo/logo_amway_ci.png`" alt="Amway (로고)" class="icoS" style="max-width:115px;">
    </div>
    <p
      v-html="title"
      class="pf23-tit fntH4 bold marBML padTML moTxtL txtC" style="color:#2c2c2c; letter-spacing: normal;"
    ></p>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { SURVEY_SYDNEY } from '@/store/actions/survey'

export default {
  name: 'SurveyHeader',
  data() {
    return {
      hybrisUrl: process.env.AMWAY_ROOT_URL,
    }
  },
  computed: {
    ...mapState(SURVEY_SYDNEY, {
      title: state => state.title,
      wave_number: state => state.wave_number,
    }),
    _title() {
      return this.title && this.wave_number ? `${this.title}` : '';
    }
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/surveys/sydney/components/SurveyHeader.vue